import React from "react";
export default function BusyIcon() {
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "20 20 60 60",
    preserveAspectRatio: "xMidYMid"
  }, React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, React.createElement("rect", {
    x: "47",
    y: "24",
    rx: "3",
    ry: "6",
    width: "6",
    height: "12",
    fill: "#fff"
  }, React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.9166666666666666s",
    repeatCount: "indefinite"
  }))), React.createElement("g", {
    transform: "rotate(30 50 50)"
  }, React.createElement("rect", {
    x: "47",
    y: "24",
    rx: "3",
    ry: "6",
    width: "6",
    height: "12",
    fill: "#fff"
  }, React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.8333333333333334s",
    repeatCount: "indefinite"
  }))), React.createElement("g", {
    transform: "rotate(60 50 50)"
  }, React.createElement("rect", {
    x: "47",
    y: "24",
    rx: "3",
    ry: "6",
    width: "6",
    height: "12",
    fill: "#fff"
  }, React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.75s",
    repeatCount: "indefinite"
  }))), React.createElement("g", {
    transform: "rotate(90 50 50)"
  }, React.createElement("rect", {
    x: "47",
    y: "24",
    rx: "3",
    ry: "6",
    width: "6",
    height: "12",
    fill: "#fff"
  }, React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.6666666666666666s",
    repeatCount: "indefinite"
  }))), React.createElement("g", {
    transform: "rotate(120 50 50)"
  }, React.createElement("rect", {
    x: "47",
    y: "24",
    rx: "3",
    ry: "6",
    width: "6",
    height: "12",
    fill: "#fff"
  }, React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5833333333333334s",
    repeatCount: "indefinite"
  }))), React.createElement("g", {
    transform: "rotate(150 50 50)"
  }, React.createElement("rect", {
    x: "47",
    y: "24",
    rx: "3",
    ry: "6",
    width: "6",
    height: "12",
    fill: "#fff"
  }, React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5s",
    repeatCount: "indefinite"
  }))), React.createElement("g", {
    transform: "rotate(180 50 50)"
  }, React.createElement("rect", {
    x: "47",
    y: "24",
    rx: "3",
    ry: "6",
    width: "6",
    height: "12",
    fill: "#fff"
  }, React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.4166666666666667s",
    repeatCount: "indefinite"
  }))), React.createElement("g", {
    transform: "rotate(210 50 50)"
  }, React.createElement("rect", {
    x: "47",
    y: "24",
    rx: "3",
    ry: "6",
    width: "6",
    height: "12",
    fill: "#fff"
  }, React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.3333333333333333s",
    repeatCount: "indefinite"
  }))), React.createElement("g", {
    transform: "rotate(240 50 50)"
  }, React.createElement("rect", {
    x: "47",
    y: "24",
    rx: "3",
    ry: "6",
    width: "6",
    height: "12",
    fill: "#fff"
  }, React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.25s",
    repeatCount: "indefinite"
  }))), React.createElement("g", {
    transform: "rotate(270 50 50)"
  }, React.createElement("rect", {
    x: "47",
    y: "24",
    rx: "3",
    ry: "6",
    width: "6",
    height: "12",
    fill: "#fff"
  }, React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.16666666666666666s",
    repeatCount: "indefinite"
  }))), React.createElement("g", {
    transform: "rotate(300 50 50)"
  }, React.createElement("rect", {
    x: "47",
    y: "24",
    rx: "3",
    ry: "6",
    width: "6",
    height: "12",
    fill: "#fff"
  }, React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.08333333333333333s",
    repeatCount: "indefinite"
  }))), React.createElement("g", {
    transform: "rotate(330 50 50)"
  }, React.createElement("rect", {
    x: "47",
    y: "24",
    rx: "3",
    ry: "6",
    width: "6",
    height: "12",
    fill: "#fff"
  }, React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite"
  }))));
}